<template>
  <ModalBase modal-type="success" @close="closeModal">
    <template #header>
      {{ $t("dialog.auth.signin.title") }}
    </template>
    <template #body>
      <p v-show="error" class="text-red-600 font-bold text-center">
        {{ error ? error : "" }}
      </p>

      <p class="font-bold text-center">
        {{ $t("dialog.auth.signin.subtitle") }}
      </p>

      <div v-if="savedUsername" class="text-center mt-2">
        <div class="text-gray-600 text-sm">
          {{ $t("dialog.auth.signin.lastLogin") }}
        </div>
        <div>
          {{ savedUsername }} (
          <span
            class="cursor-pointer underline text-sm"
            @click="removeLastLogin"
          >
            {{ $t("dialog.auth.signin.notMe") }}
          </span>
          )
        </div>
      </div>
      <div v-else>
        <input
          v-model="username.value"
          class="border border-gray-500 rounded py-2 pl-2 mt-3 w-full pkss-input"
          :class="{ 'border-red-600': username.error }"
          placeholder="Benutzername"
        />
        <label v-if="username.error !== ''" class="text-red-600">
          {{ username.error }}
        </label>
      </div>

      <input
        v-model="password.value"
        type="password"
        class="border border-gray-500 rounded py-2 pl-2 mt-3 pkss-input"
        :class="{ 'border-red-600': password.error }"
        placeholder="Password"
        @keyup.enter="signin"
      />
      <label v-if="password.error !== ''" class="text-red-600">
        {{ password.error }}
      </label>

      <div class="mt-2">
        <input
          id="keepLoggedIn"
          v-model="keepLoggedIn"
          type="checkbox"
          class="mr-2 pkss-input"
        />
        <label class="text-gray-600 inline" for="keepLoggedIn">
          {{ $t("dialog.auth.signin.keeploggedin") }}
        </label>
      </div>
    </template>
    <template #footer-without-padding>
      <div class="w-full flex justify-between px-4 pb-4">
        <!--<div class="text-sm cursor-pointer"
                     @click="$router.push({ name: 'forgot-password'})">
                    {{ $t('dialog.auth.signin.forgotpassword') }}
                </div>-->
        <div>
          <button class="pkss-btn primary" @click="signin">
            {{ $t("dialog.auth.signin.signin") }}
          </button>
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
//import { mapState } from "vuex";
import ModalBase from "@/components/shared/ModalBase";

export default {
  name: "SignInModal",
  components: { ModalBase },
  props: {
    preventRedirectOnClose: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: true,
      error: "",
      username: {
        value: "",
        error: ""
      },
      password: {
        value: "",
        error: ""
      },
      keepLoggedIn: false
    };
  },
  /*computed: {
    ...mapState("auth", {
      authenticationError: "authenticationError",
      savedUsername: "savedUsername",
      user: "user"
    })
  },*/
  created() {
    this.username.value = this.savedUsername;
  },
  methods: {
    async signin() {
      this.$store
        .dispatch("auth/login", {
          username: this.username.value,
          password: this.password.value
        })
        .then(() => {
          // Sprache setzen nach login
          this.$store.dispatch("auth/user").then(() => {
            if (this.user) {
              if (this.user.language !== "") {
                this.$root.$i18n.locale = this.user.language;
              }
            }
          });

          if (this.$router.history.current.query.redirect) {
            this.$router
              .push(this.$router.history.current.query.redirect)
              .catch(() => {});
          } else {
            this.$router.push({ name: "app" }).catch(() => {});
          }

          this.$store.dispatch("auth/filter");
          this.$store.dispatch("mission/filter");
        })
        .catch(error => {
          this.error = error.message;
        });
    },

    removeLastLogin() {
      this.username.value = "";
      this.$store.commit("auth/removeLastUsername");
    },

    closeModal() {
      if (!this.preventRedirectOnClose) {
        this.$router.push("/").catch(() => {});
      } else {
        this.$emit("close");
      }
    }
  }
};
</script>

<style scoped></style>
